// Form validation for Mail server settings form
import { emailValidator, plaintextValidator } from '../fields';

const config = {};

export const salesMailSettingsConstraints = {
  incomingEmailAddress: emailValidator({ mandatory: true }),
  //   replyTo: emailValidator(config),
  replyTo: {
    email: true,
    equality: {
      attribute: 'senderName',
      message: '^Make sure you fill in Sender Name',
      comparator: (v1, v2) => {
        if (!v2) {
          return false;
        }
        return true;
      }
    }
  },
  senderName: {
    equality: {
      attribute: 'replyTo',
      message: '^Make sure you fill in Reply To Email',
      comparator: (v1, v2) => {
        if (!v2) {
          return false;
        }
        return true;
      }
    }
  }
};
